import React from 'react'
// Custom Component
import NavbarComponent from "../../components/layouts/Navbar";
import ProgressAssociatedCompanies from '../../components/associatedCompanies/ProgressAssociatedCompanies';
import Footer from '../../components/layouts/Footer'

const AssociatedCompaniesPage = () => {
  return (
    <>
      <NavbarComponent />
      <ProgressAssociatedCompanies />
      <Footer />
    </>
  )
}

export default AssociatedCompaniesPage